<template>
  <supplier-component :storeType="storeType"/>
</template>

<script>
import SupplierComponent from './SupplierComponent'

export default {
  name: 'distributionstore',
  components: {SupplierComponent},
  data () {
    return {
      storeType: 10
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/distributionstore.vue